import { load } from "@cashfreepayments/cashfree-js";
import api from "@/lib/api";

let cashfreeInstance = null;
let loadedMode = null;

// Loads the official Cashfree JS SDK in the mode reported by the backend.
export async function getCashfree(mode) {
  if (cashfreeInstance && loadedMode === mode) return cashfreeInstance;
  cashfreeInstance = await load({ mode: mode === "production" ? "production" : "sandbox" });
  loadedMode = mode;
  return cashfreeInstance;
}

// Creates a server-side order, opens Cashfree Checkout, then lets the caller
// confirm final status via the backend (server-side verification is authoritative).
export async function startProcessingFeePayment() {
  const { data } = await api.post("/payments/create-order");
  const cashfree = await getCashfree(data.mode);
  await cashfree.checkout({
    paymentSessionId: data.payment_session_id,
    redirectTarget: "_modal",
  });
  return data.order_id;
}
